<template>
  <component :is="way" :response-id="responseId" :response="response" :test="test" :loaded="loaded" />
</template>

<script>
import store from '../stores.js';
import { mapGetters, mapActions } from 'vuex';
import { STORE_PREFIX } from '../constants';
import DefaultTest from './default';
const JtiJumpTest = () => import(/* webpackChunkName: "innerjti" */ '@/process/innerjti/components/candidate/test');
const SchlumCareerCandidateTests = () =>
  import(/* webpackChunkName: "schlum-career-test" */ '@/process/schlumberger-career/components/candidate/test');

export default {
  name: 'CandidateTests',

  components: {
    basic: DefaultTest,
    innerjti: JtiJumpTest,
    'schlum-career': SchlumCareerCandidateTests
  },

  mixins: [store],

  props: {
    response: {
      type: Object,
      default: () => {}
    },

    responseId: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'test', {
      test: 'item',
      loaded: 'loaded',
      error: 'error'
    }),

    ...mapGetters('process', ['getProcessName']),

    way() {
      if (this.getProcessName === 'innerjti' || this.getProcessName === 'schlum-career') {
        return this.getProcessName;
      }
      return 'basic';
    }
  },

  beforeMount() {
    this.fetch(this.responseId).catch(error => this.$noty.error(error.message ? error.message : error));
  },

  methods: {
    ...mapActions(STORE_PREFIX + 'test', ['fetch'])
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: $red;
}
</style>
